class KitCartDrawer {
  constructor() {
    this.onClick = this.onClick.bind(this);
    document.addEventListener('click', this.onClick);
  }

  async onClick(event) {
    const button = event.target.closest('[data-kit-group-remove]');
    if (!button) return;

    event.preventDefault();
    const kitGroup = button.dataset.kitGroupRemove;
    if (!kitGroup) return;

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');

    try {
      await this.removeKitGroup(kitGroup);
    } catch (error) {
      console.error(error);
    } finally {
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
    }
  }

  async removeKitGroup(kitGroup) {
    const cartResponse = await fetch(`${routes.cart_url}.js`);
    if (!cartResponse.ok) {
      throw new Error('Não foi possível carregar o carrinho.');
    }

    const cartData = await cartResponse.json();
    const updates = {};

    cartData.items.forEach((item) => {
      if (item.properties?._kit_group === kitGroup) {
        updates[item.key] = 0;
      }
    });

    if (!Object.keys(updates).length) return;

    const cartDrawer = document.querySelector('cart-drawer');
    const payload = { updates };

    if (cartDrawer) {
      payload.sections = cartDrawer.getSectionsToRender().map((section) => section.id);
      payload.sections_url = '/cart';
    }

    const response = await fetch(routes.cart_update_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();
    if (data.status) {
      throw new Error(data.description || data.message || 'Não foi possível remover o kit.');
    }

    if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'kit-cart-drawer',
        cartData: data,
      });
    }

    if (cartDrawer && data.sections) {
      if (data.item_count === 0) {
        cartDrawer.classList.add('is-empty');
      } else {
        cartDrawer.classList.remove('is-empty');
      }
      cartDrawer.renderContents(data);
      return;
    }

    window.location.reload();
  }
}

new KitCartDrawer();
